import Landing from "../components/landing";
import Nav from "./nav";

import "../App.css";

function Main() {
  return (
    <>
      <Nav navClass="contentpage" />

      <div className="z-0 p-0 border-0 border-white">
        <Landing />
      </div>
    </>
  );
}

export default Main;
